module.exports = __webpack_public_path__ + "static/media/koi-fish-cutout-4.b6ba7870.png";